declare let saleData: any;

/**
 * Handle payment callback
 *
 * @param {object} data payment result object of Altapay response
 * @param {string} type type of result of operation: 'success', 'fail'
 */
const resultHandler = (data, type = 'success') => {
    const redirect = (data, type) => {
        const { shop_orderid, transaction_id } = data;
        const [date, time] = (new Date()).toLocaleString('Sv').split(' ');

        const redirectUrl = getRedirectUrl();
        if (!redirectUrl) {
            return;
        }

        let url = '';

        const separator = redirectUrl.includes('?') ? '&' : '?';
        if (type === 'success') {
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            const bookingTransId = urlParams.get('tid');
            url = `${redirectUrl}${separator}txnid=${transaction_id}&orderid=${shop_orderid}&date=${date}&time=${time}&booktid=${bookingTransId}`;
        } else if (type === 'fail') {
            url = `${redirectUrl}`;
        }

        if (url) {
            window.location.replace(url);
        }
    };

    /**
     * Read a redirect URL from a global variable 'saleData'.
     * This one can have two formats:
     *  - {url}/?criteo=XXXXXX-XXXX for sale page
     *  - {url}/ for payment page
     *
     * @param {string} page available types: 'accepturl', 'cancelurl'
     * @returns {*|boolean}
     */
    const getRedirectUrl = (page = 'accepturl') => {
        if ('saleData' in window && Object.prototype.hasOwnProperty.call(saleData, page) && typeof saleData[page] === 'string') {
            return saleData[page];
        }

        return false;
    };

    redirect(data, type);
};

/**
 * Change number of attempt for Vipps gateway.
 * Because Vipps support only one attempt with unique orderId.
 *
 * @param {object} props data for register payment intent
 */
const vippsOrderIdHandler = (props) => {
    const key = 'altapay.vipps.orderId';
    const { orderId, terminal } = props;

    const getDataFromStorage = (key) => {
        const storage = window.localStorage.getItem(key);
        if (storage) {
            try {
                return JSON.parse(storage);
            } catch {
                window.localStorage.removeItem(key);
            }
        }

        return {};
    };

    const saveDataToStorage = (key, data) => {
        try {
            window.localStorage.setItem(key, JSON.stringify(data));
        } catch {
            //
        }
    };

    const updateAttempt = (data = {}, orderId = '') => {
        if (Object.hasOwnProperty.call(data, orderId)) {
            data[orderId] = data[orderId] + 1;
        } else {
            data[orderId] = 1;
        }
    };

    const getOrderIdWithAttempt = (data = {}, orderId = '') => {
        if (!Object.hasOwnProperty.call(data, orderId)) {
            return orderId;
        }

        if (data[orderId] > 1) {
            return `${props.orderId}a${data[orderId]}`;
        }

        return orderId;
    };

    if (window === undefined || !('localStorage' in window) || terminal !== 'vipps') {
        return;
    }

    const data = getDataFromStorage(key);
    updateAttempt(data, orderId);
    saveDataToStorage(key, data);
    props.orderId = getOrderIdWithAttempt(data, orderId);
};

export { resultHandler, vippsOrderIdHandler };
